import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function Team() {
  const teamMembers = [
    {
      name: "Artan Shala",
      position: "Kryekontabilist & Partner",
      experience: "30+ vjet përvojë",
      expertise: "Kontabilitet, Tatime, Auditim",
      description: "Ekspert i certifikuar me përvojë të gjerë në fushën e kontabilitetit dhe tatimeve."
    },
    {
      name: "Drita Shala",
      position: "Konsulente Financiare",
      experience: "12+ vjet përvojë",
      expertise: "Konsulencë Financiare, Analizë Biznesi",
      description: "Specialiste në planifikim financiar dhe strategji biznesi."
    },
    {
      name: "Blerim Shala",
      position: "Ekspert i Tatimeve",
      experience: "10+ vjet përvojë",
      expertise: "Tatime, Përputhshmëri",
      description: "Ekspert në optimizimin e tatimeve dhe përputhshmërinë ligjore."
    },
    {
      name: "Valmira Shala",
      position: "Kontabiliste Senior",
      experience: "8+ vjet përvojë",
      expertise: "Kontabilitet, Raportim",
      description: "Specialiste në raportimin financiar dhe analizën e të dhënave."
    }
  ];

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>Ekipi Ynë</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="team-intro">
            <h2>Njohuni me Ekipin Tonë</h2>
            <p>Ekipi ynë përbëhet nga profesionistë të certifikuar me përvojë të gjerë në fushën e kontabilitetit, tatimeve dhe konsulencës biznesi. Secili anëtar i ekipit kontribuon me ekspertizën e tyre unike për të ofruar shërbimet më cilësore për klientët tanë.</p>
          </div>
          
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-member">
                <div className="member-avatar">
                  <div className="avatar-placeholder">
                    {member.name.split(' ').map(n => n[0]).join('')}
                  </div>
                </div>
                <div className="member-info">
                  <h3>{member.name}</h3>
                  <h4>{member.position}</h4>
                  <p className="experience">{member.experience}</p>
                  <p className="expertise"><strong>Ekspertizë:</strong> {member.expertise}</p>
                  <p className="description">{member.description}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="team-values">
            <div className="values-grid">
              <div className="value-card">
                <h3>Certifikime Profesionale</h3>
                <p>Të gjithë anëtarët e ekipit kanë certifikimet e nevojshme në fushën e tyre</p>
              </div>
              <div className="value-card">
                <h3>Përvojë e Gjerë</h3>
                <p>Kombinuar më shumë se 45 vjet përvojë në industri</p>
              </div>
              <div className="value-card">
                <h3>Përditësim i Vazhdueshëm</h3>
                <p>Ndiqim zhvillimet më të fundit në legjislacion dhe praktika</p>
              </div>
              <div className="value-card">
                <h3>Qasje Personale</h3>
                <p>Secili klient ka një kontakt të drejtpërdrejtë me ekspertin e tyre</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Team; 